var _style, _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "calendar_icon",
    xmlnscc: "http://creativecommons.org/ns#",
    xmlnsdc: "http://purl.org/dc/elements/1.1/",
    xmlnsrdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    ref: svgRef
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#CFD8DC;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\r\n\t.st1{fill:#E74C3C;}\r\n\t.st2{fill:#C0392B;}\r\n\t.st3{fill:#666666;}\r\n\t.st4{fill:#CCCCCC;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1028.4)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4,1030.7c-1.3,0-2.3,0.9-2.3,2v14.2c0,1.1,1,2,2.3,2H11h2.3h6.9c1.3,0,2.3-0.9,2.3-2v-14.2c0-1.1-1-2-2.3-2 h-6.9H11H4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4,1030.7c-1.3,0-2.3,0.9-2.3,2v3h20.8v-3c0-1.1-1-2-2.3-2h-6.9H11H4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M7.5,1032.2c0,0.8-0.7,1.5-1.5,1.5s-1.5-0.7-1.5-1.5c0-0.8,0.7-1.5,1.5-1.5S7.5,1031.4,7.5,1032.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M19.5,1032.2c0,0.8-0.7,1.5-1.5,1.5s-1.5-0.7-1.5-1.5c0-0.8,0.7-1.5,1.5-1.5S19.5,1031.4,19.5,1032.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M5.6,1037.9v2h2.3v-2H5.6z M9.1,1037.9v2h2.3v-2H9.1z M12.6,1037.9v2h2.3v-2H12.6z M16.1,1037.9v2h2.3v-2 H16.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M5.6,1040.9v2h2.3v-2H5.6z M9.1,1040.9v2h2.3v-2H9.1z M12.6,1040.9v2h2.3v-2H12.6z M16.1,1040.9v2h2.3v-2 H16.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M5.6,1043.9v2h2.3v-2H5.6z M9.1,1043.9v2h2.3v-2H9.1z M12.6,1043.9v2h2.3v-2H12.6z M16.1,1043.9v2h2.3v-2 H16.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M6,1028.4c-0.6,0-1,0.4-1,0.9v2.8c0,0.5,0.4,0.9,1,0.9s1-0.5,1-0.9v-2.8C7,1028.8,6.6,1028.4,6,1028.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M18,1028.4c-0.6,0-1,0.4-1,0.9v2.8c0,0.5,0.4,0.9,1,0.9s1-0.5,1-0.9v-2.8C19,1028.8,18.6,1028.4,18,1028.4z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar.d42138f2.svg";
export { ForwardRef as ReactComponent };